import { NgModule }        					            from '@angular/core';
import { HttpClientModule,HTTP_INTERCEPTORS} 	        from '@angular/common/http';
import { BrowserModule }   					            from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule}              from '@angular/forms';
import { MatNativeDateModule } 				            from '@angular/material';
import { platformBrowserDynamic } 			            from '@angular/platform-browser-dynamic';
import { BrowserAnimationsModule }                      from '@angular/platform-browser/animations';

import { WebcamModule }                                 from 'ngx-webcam';
import { ChartsModule }                                 from 'ng2-charts';
import { NgxSpinnerModule }                             from 'ngx-spinner';
import { SocketIoModule, SocketIoConfig }               from 'ngx-socket-io';
import { NgbModule } 							        from '@ng-bootstrap/ng-bootstrap';
import { SweetAlert2Module }                            from '@toverux/ngx-sweetalert2';

import { AppRoutingModule }                             from './app-routing.module';
import { DemoMaterialModule }                           from './material-module';
import { AppComponent }                                 from './app.component';
import { HeaderComponent }                              from './layouts/header.component';
import { LoginComponent }                               from './login/login.component';
import { OtpComponent }                                 from './otp/otp.component';
import { VerifyComponent }                              from './verify/verify.component';
import { UploadpicComponent }                           from './verify/upload-pic.component';
import { LaunchpageComponent }                          from './verify/launch-page.component';
import { TestComponent }                                from './test/test-page.component';
import { TestNoStreamComponent }                        from './test/test-page-nostream.component';
import { VivaComponent }                                from './test/viva-page.component';

import { PublisherComponent }                           from './publisher/publisher.component';
import { SubscriberComponent }                          from './subscriber/subscriber.component';

import {VgCoreModule}                                   from 'videogular2/core';
import {VgControlsModule}                               from 'videogular2/controls';
import {VgOverlayPlayModule}                            from 'videogular2/overlay-play';
import {VgBufferingModule}                              from 'videogular2/buffering';

import { AlertComponent }                               from './_directives';
import { AuthGuard }                                    from './_guards';
import { JwtInterceptor, ErrorInterceptor, Globals  }   from './_helpers';
import { ConstantsService }                             from './common/services/constants.service';
import { UploadidpicComponent }                         from './verify/upload-idpic.component';
import { PracticalLaunchpageComponent }                 from './verify/practical-launch-page.component';
import { FeedbackstartComponent }                       from './verify/feedback-start.component';
import { FeedbackComponent }                            from './verify/feedback.component';
import { PracticalComponent }                           from './test/practical-page.component';
import { ThanksComponent }                              from './test/thanks-page.component';
import { AlertService, AuthenticationService, UserService, OtpService, VerifystudentService, PhotoauthService, LunchpageService, ExamService, OpentokService } from './_services';
import { DescriptiveExamComponent } from './descriptive-exam/descriptive-exam.component';
import { CanvasComponent } from './canvas/canvas.component';
import { NewCanvasComponent } from './new-canvas/new-canvas.component';
import { DatePipe } from '@angular/common';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { DataTableModule } from "angular-6-datatable";
import { AngularMonacoEditorConfig, AngularMonacoEditorModule } from 'angular-monaco-editor';

import { UserLoginComponent } from './login/user-login.component';
import { UserSignupComponent } from './login/user-signup.component';
import { LoginotpComponent } from './login/loginotp.component';
import { ForgetUsernameComponent } from './forget-username/forget-username.component';
import { MyProfileComponent } from './my-profile/my-profile.component';
import { ForgetPasswordComponent } from './forget-password/forget-password.component';
import { VerifyOtpComponent } from './forget-password/verifyotp.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { AadhaarOtpComponent } from './verify/aadhaar-otp.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HomeComponent } from './login/home.component';
import { CheckOtpComponent } from './login/checkotp.component';
import { SectorComponent } from './dashboard/sector.component';
import { QualificationComponent } from './dashboard/qualification.component';
import { InstructionComponent } from './dashboard/instruction.component';
import { EditProfileComponent } from './my-profile/edit-profile.component';
import { ResultsComponent } from './dashboard/results.component';
import { BuyexamComponent } from './dashboard/buyexam.component';
import { TransactionComponent } from './dashboard/transaction.component';
import { PsychometricComponent } from './psychometric/psychometric.component';
import { PsychometricWlsComponent } from './psychometric/psychometric-wls.component';
import { TypingSimulationComponent } from './typing/typing-simulation.component';
import { AdaptiveLaunchpageComponent } from './adaptive/adaptive-launch-page.component';
import { AdaptiveComponent } from './adaptive/adaptive.component';
import { AdaptiveWlsComponent } from './adaptive/adaptive-wls.component';
import { Test3Component } from './theory3/test-page.component';
import { Test3NoStreamComponent } from './theory3/test-page-nostream.component';
import { GeocodeService } from './_services/geocode.service';

// import { CanvasWhiteboardModule } from 'ng2-canvas-whiteboard/dist/ng2-canvas-whiteboard';
//firebase
/*import { AngularFireModule } from '@angular/fire';
//import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireDatabase } from '@angular/fire/database';
//import { AngularFireAuthModule } from '@angular/fire/auth';
import { environment } from '../environments/environment';

import { AngularFireModule } from 'angularfire2';
// for AngularFireDatabaseAadhaarOtpComponent
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireDatabase, FirebaseObjectObservable } from 'angularfire2/database';
// for AngularFireAuth
import { AngularFireAuthModule } from 'angularfire2/auth';
import { AngularFireAuth } from 'angularfire2/auth';*/


const config: SocketIoConfig = { url: 'http://localhost:1337', options: {} };

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    DemoMaterialModule,
    ReactiveFormsModule,
    MatNativeDateModule,
    NgbModule,
    WebcamModule,
    ChartsModule,
    NgxSpinnerModule,
    VgCoreModule,
    VgControlsModule,
    VgOverlayPlayModule,
    VgBufferingModule,
    SweetAlert2Module.forRoot(),
    SocketIoModule.forRoot(config),
    AngularEditorModule,
    DataTableModule,
    AngularMonacoEditorModule.forRoot() // use forRoot() in Angular 6
     
    //AngularFireModule.initializeApp(environment.firebase),
    //AngularFireAuthModule,AngularFirestoreModule,
  ],
  declarations: [
    AppComponent,
    HeaderComponent,
    LoginComponent,
    HomeComponent,
    OtpComponent,
    VerifyComponent,
    UploadpicComponent,
    LaunchpageComponent,
    TestComponent,
    VivaComponent,
    AlertComponent,
    PublisherComponent,
    SubscriberComponent,
    TestNoStreamComponent,
    UploadidpicComponent,
    PracticalLaunchpageComponent,   
    PracticalComponent,
    ThanksComponent,
    DescriptiveExamComponent,
    FeedbackstartComponent,
    FeedbackComponent,
    CanvasComponent,
    NewCanvasComponent,
    UserLoginComponent,
    MyProfileComponent,
    ForgetPasswordComponent,
    VerifyOtpComponent,
    ResetPasswordComponent,
    ChangePasswordComponent,
    AadhaarOtpComponent,
    ForgetUsernameComponent,
    LoginotpComponent,
    UserSignupComponent,
    DashboardComponent,
    CheckOtpComponent,
    SectorComponent,
    QualificationComponent,
    InstructionComponent,
    EditProfileComponent,
    ResultsComponent,
    BuyexamComponent,
    TransactionComponent,
    PsychometricComponent,
    PsychometricWlsComponent,
    TypingSimulationComponent,
    AdaptiveLaunchpageComponent,
    AdaptiveComponent,
    AdaptiveWlsComponent,
    Test3Component,
    Test3NoStreamComponent
  ],
  entryComponents: [AppComponent, SubscriberComponent],
  bootstrap: [AppComponent],
  providers: [
    DatePipe,
    Globals, 
    AuthGuard,
    AlertService,
    AuthenticationService,
    UserService,
    OtpService,
    VerifystudentService,
    PhotoauthService,
    LunchpageService,
    ExamService,
    ConstantsService,
    OpentokService,
    GeocodeService,
    { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
  ]
})
export class AppModule { }

platformBrowserDynamic().bootstrapModule(AppModule);



